import { render, staticRenderFns } from "./forgetPassword.vue?vue&type=template&id=437a9eaa&scoped=true&"
import script from "./forgetPassword.vue?vue&type=script&lang=ts&"
export * from "./forgetPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437a9eaa",
  null
  
)

export default component.exports